export const VERIFY_SUCCESS_HTTP_STATUS = 200;
export const VERIFY_FAILURE_HTTP_STATUS = 401;

export const VERIFY_TIMEOUT_ERROR_MESSAGE = 'Request timeout exceeded';
